import { Icon, Typography } from '@fox/atoms';
import { FlexRowSmallSpaced } from '@fox/layout';
import React from 'react';
import { useComponentStyleContext } from '../component-style-context';
import { Breadcrumb } from './contracts';
import { PAGE_TYPES } from '../page-types';

function RenderNoLink({ b }: { b: Breadcrumb }) {
	const { font, fontColour, fontSizeRem, fontTextShadow } = useComponentStyleContext();
	return (
		<Typography
			style={{
				...font,
				...fontColour,
				...fontSizeRem,
				...fontTextShadow
			}}
		>
			{b.name}
		</Typography>
	);
}

function RenderLink({ b }: { b: Breadcrumb }) {
	const { font, fontColour, fontSizeRem, fontTextShadow, linkHoverColour, linkHoverUnderline } = useComponentStyleContext();

	return (
		<a
			style={{
				textDecoration: 'none',
				color: 'inherit',
				width: 'max-content',
				display: 'block'
			}}
			href={b.url}
			target="_self"
		>
			<Typography
				style={{
					...font,
					...fontColour,
					...fontSizeRem,
					...fontTextShadow,
					...linkHoverColour,
					...linkHoverUnderline
				}}
			>
				{b.name}
			</Typography>
		</a>
	);
}

export function Breadcrumbs({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) {
	const { font, fontColour, fontSizeRem, fontTextShadow } = useComponentStyleContext();
	const sortedBreadcrumbs = breadcrumbs?.sort((a, b) => (a.level > b.level ? 1 : b.level > a.level ? -1 : 0)) ?? [];

	return (
		<FlexRowSmallSpaced
			style={{
				...font,
				...fontColour,
				...fontSizeRem,
				...fontTextShadow,
				alignItems: 'center'
			}}
		>
			{sortedBreadcrumbs.map((b, i) => {
				const isCurrent = i === sortedBreadcrumbs.length - 1;
				const renderLink = !isCurrent && b.type !== PAGE_TYPES.PAGE_FOLDER;
				return (
					<React.Fragment key={i}>
						{renderLink ? <RenderLink b={b} /> : <RenderNoLink b={b} />}
						{!isCurrent ? <Icon iconName="ArrowForwardIos" color="inherit" /> : null}
					</React.Fragment>
				);
			})}
		</FlexRowSmallSpaced>
	);
}
